import { skipToken, useQuery } from '@tanstack/react-query'

import { getAssistantTierConfig } from '../api/assistant-tier-api'
import { assistantTierKeys } from '../api/query-keys'

export function useAssistantTierConfig(entityId: string | null) {
  return useQuery({
    queryKey: assistantTierKeys.config(entityId ?? ''),
    queryFn: entityId === null ? skipToken : () => getAssistantTierConfig(entityId),
  })
}
